import { MAX_METRIC_GROUPS } from "@/shared/domain/metrics/MetricRecord";

/**
 * The words a grouped card uses when the server's group cap left groups out:
 * the legend's trailing note, its explanation, the caption's "top N of M", and
 * the drill-down's note. Kept together so every surface says the same thing.
 */

const count = (n: number) => n.toLocaleString("en-US");

/** Which groups a capped chart shows, and how to reach the others. */
export const GROUP_CAP_EXPLANATION = `Showing the ${MAX_METRIC_GROUPS} groups with the most sessions in this window. Filter the dashboard to see others.`;

/** The legend's trailing note: how many groups are not drawn. `null` when the
 *  server said groups were left out but not how many. */
export function hiddenGroupsText(hiddenGroups: number | null): string {
  if (hiddenGroups === null) {
    return "More groups not shown";
  }
  return `+${count(hiddenGroups)} more ${hiddenGroups === 1 ? "group" : "groups"} not shown`;
}

/** The caption's statement of the cap, e.g. "top 100 of 3,412". */
export function groupCapCaption(totalGroups: number | null): string {
  return totalGroups === null
    ? `top ${MAX_METRIC_GROUPS}`
    : `top ${MAX_METRIC_GROUPS} of ${count(totalGroups)}`;
}
